import type { PackNode, PackNodeData } from '../../../lib/bubble/packNodeTypes';

/** Single path segment for a pack node (no ancestry). */
export function bubbleNodeSegment(data: PackNodeData | null | undefined): string {
  if (!data) return 'unknown';
  const t = data.type;
  if (t === 'status' || t === 'reason') return `${t}:${data.key}`;
  return `${t}:${data.name}`;
}

/** Stable key for matching bubbles across drill re-renders. */
export function bubbleNodeKey(d: PackNode): string {
  if (d.data?._isOverflow) {
    return `overflow:${d.data._overflowParentKey ?? 'root'}`;
  }
  if (d.data?.type === 'volume') {
    return `vol:${d.data.volume?.ebsId}`;
  }

  const segments: string[] = [];
  let node: PackNode | null | undefined = d;
  while (node?.data) {
    if (node.depth === 0) break;
    segments.unshift(bubbleNodeSegment(node.data));
    node = node.parent;
  }

  if (segments.length === 0) {
    return bubbleNodeSegment(d.data);
  }
  return segments.join('/');
}
